import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { liveUpdateStore } from '../../../store/liveUpdateStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { DefaultQueryParams } from '../../../core/constants/defaultQueryParams';
import { parseQuery } from '../../../core/helpers/parseQuery';
import { LiveBetsColumnByGame } from '../../../core/constants/liveBetsColumnByGame';
import useTranslation from '../../../hooks/useTranslation';
import Table from '../../../components/table';

const HighRollers = observer(() => {
  const { highRollers } = liveUpdateStore;
  const { search } = useLocation();
  const { rate, precision, userId, currencyCode } = userInfoStore;
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const t = useTranslation();

  const gameLiveSpinsByGame = useMemo(() => {
    return LiveBetsColumnByGame[gameId];
  }, [gameId]);

  return (
    <Table
      t={t}
      rate={rate}
      data={highRollers}
      precision={precision}
      currentUserId={userId}
      currency={currencyCode}
      columns={gameLiveSpinsByGame}
    />
  );
});
export default HighRollers;
